import axios from 'axios';
import { API } from '../config/api';

// Create axios instance with default config
// TODO refactor this to use the axios instance from the api service
const axiosInstance = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Helper function to generate request ID
// const generateRequestId = () => uuidv4();

// Helper function to get headers with request ID
// const getHeaders = () => ({
//   'x-request-id': generateRequestId(),
// });

// Blockchain API functions
export const blockchainService = {
  // Create new blockchain record
  create: async (data: any) => {
    const response = await axiosInstance.post(API.BLOCKCHAIN.create, data, {
      withCredentials: true,
      // headers: getHeaders(),
    });
    return response.data;
  },

  // Get all blockchain records
  getAllBlockchain: async () => {
    const response = await axiosInstance.get(API.BLOCKCHAIN.getAll, {
      withCredentials: true,
      // headers: getHeaders(),
    });
    return response.data;
  },

  // Get blockchain records by history hash
  //   getByHistoryHash: async (hash: string) => {
  //     const response = await axiosInstance.get(API.BLOCKCHAIN.getByHash(hash), {
  //       withCredentials: true,
  //       // headers: getHeaders(),
  //     });
  //     return response.data;
  //   },

  // Get blockchain records by request ID
  getByReqId: async (reqId: string) => {
    const response = await axiosInstance.get(API.BLOCKCHAIN.getByReqId(reqId), {
      withCredentials: true,
      // headers: getHeaders(),
    });
    return response.data;
  },

  //   // Update blockchain record
  //   updateBlockchain: async (hash: string, data: any) => {
  //     const response = await axiosInstance.patch(API.BLOCKCHAIN.update(hash), data, {
  //       withCredentials: true,
  //       // headers: getHeaders(),
  //     });
  //     return response.data;
  //   },

  // Delete blockchain record
  deleteBlockchain: async (reqId: string) => {
    const response = await axiosInstance.delete(API.BLOCKCHAIN.delete(reqId), {
      withCredentials: true,
      // headers: getHeaders(),
    });
    return response.data;
  },
};
